import React from 'react'
import { DocumentMagnifyingGlassIcon } from "@heroicons/react/24/outline";
import ListItemTab from "./ListItemTab";

const ReportEvaluationItem = ({ onClick, active }) => {
    return (
        <ListItemTab
            icon={DocumentMagnifyingGlassIcon}
            label="Report Evaluation"
            onClick={onClick}
            active={active}
        />
    )
}

export default ReportEvaluationItem
